//Paquetes NPM de GYF. 
import { LogHelper } from 'com-gyf-webcore-loghelper';

import { Engine1Proxy, RestApiProxy, ConciergeProxy, SagasHelper } from 'com-gyf-webcore-servicehub';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

import ProductoManager from '../../../Common/Managers/ProductoManager';
import ProcessManager from '../../../Common/Managers/ProcessManager';
import { debug } from 'util';

let _dispatch = null;
let _productoId = undefined;
let _administradoraId;
let _userFeatures = [];
let _userFunctions = [];

// ACTION TYPES
export const INITIAL_STATE_PRODUCTO = 'INITIAL_STATE_PRODUCTO';
export const GET_SCREEN_DATA_PRODUCTO = 'GET_SCREEN_DATA_PRODUCTO';
export const READY_REQUEST_PRODUCTO = 'READY_REQUEST_PRODUCTO';
export const GET_SCREEN_DATA_RESULT_PRODUCTO = 'GET_SCREEN_DATA_RESULT_PRODUCTO';
export const SAVE_SELECTED_BRANCHES_PRODUCTO = 'SAVE_SELECTED_BRANCHES_PRODUCTO';
export const CANCEL_SELECTED_BRANCHES_PRODUCTO = 'CANCEL_SELECTED_BRANCHES_PRODUCTO';
export const REMOVE_SELECTED_BRANCH_PRODUCTO = 'REMOVE_SELECTED_BRANCH_PRODUCTO';
export const NO_SUCURSAL_SELECTED_PRODUCTO = 'NO_SUCURSAL_SELECTED_PRODUCTO';
export const NO_SELECCION_AMBAS_REGLAS_AVANZADAS_PRODUCTO = 'NO_SELECCION_AMBAS_REGLAS_AVANZADAS_PRODUCTO';
export const ERROR_SAVE_PRODUCTO = 'ERROR_SAVE_PRODUCTO';
export const SHOW_MORE_BRANCHES_PRODUCTO = 'SHOW_MORE_BRANCHES_PRODUCTO';
export const SHOW_LESS_BRANCHES_PRODUCTO = 'SHOW_LESS_BRANCHES_PRODUCTO';
export const SAVE_SELECTED_PURCHASE_LIMITS_PRODUCTO = 'SAVE_SELECTED_PURCHASE_LIMITS_PRODUCTO';
export const CANCEL_SELECTED_PURCHASE_LIMITS_PRODUCTO = 'CANCEL_SELECTED_PURCHASE_LIMITS_PRODUCTO';
export const REMOVE_SELECTED_PURCHASE_LIMIT_PRODUCTO = 'REMOVE_SELECTED_PURCHASE_LIMIT_PRODUCTO';
export const SHOW_MORE_PURCHASE_LIMITS_PRODUCTO = 'SHOW_MORE_PURCHASE_LIMITS_PRODUCTO';
export const SHOW_LESS_PURCHASE_LIMITS_PRODUCTO = 'SHOW_LESS_PURCHASE_LIMITS_PRODUCTO';
export const SHOW_SAVE_STATUS_PRODUCTO = 'SHOW_SAVE_STATUS_PRODUCTO';
export const GET_DATA_BY_ADMINISTRATOR_ID_PRODUCTO = 'GET_DATA_BY_ADMINISTRATOR_ID_PRODUCTO';
export const GET_OPTIONS_BY_FIELD_PRODUCTO = 'GET_OPTIONS_BY_FIELD_PRODUCTO';
export const REMOVE_ADVANCED_RULE_PRODUCTO = 'REMOVE_ADVANCED_RULE_PRODUCTO';
export const ADD_ADVANCED_RULE_PRODUCTO = 'ADD_ADVANCED_RULE_PRODUCTO';
export const DUPLICATE_ADVANCED_RULE_PRODUCTO = 'DUPLICATE_ADVANCED_RULE_PRODUCTO';
export const SAVE_PRE_POST_OPTIONS_PRODUCTO = 'SAVE_PRE_POST_OPTIONS_PRODUCTO';
export const REMOVE_PRE_POST_SELECTED_OPTION_PRODUCTO = 'REMOVE_PRE_POST_SELECTED_OPTION_PRODUCTO';
export const SELECT_CHECKBOX_PRODUCTO = 'SELECT_CHECKBOX_PRODUCTO';
export const SELECT_COMBO_PRODUCTO = 'SELECT_COMBO_PRODUCTO';
export const SELECT_RADIO_PRODUCTO = 'SELECT_RADIO_PRODUCTO';
export const CHANGE_INPUT_PRODUCTO = 'CHANGE_INPUT_PRODUCTO';
export const SET_USER_FUNCTIONS_PRODUCTO = 'SET_USER_FUNCTIONS_PRODUCTO';
export const FUNCTION_CODE_CREATE_PRODUCTO = 'Alta';
export const FUNCTION_CODE_QUERY = 'Consulta';
export const FUNCTION_CODE_MODIFICATION_PRODUCTO = 'Modificacion';
export const FUNCTION_CODE_DISTRIBUTION_PRODUCTO = 'Distribucion';
export const FUNCTION_CODE_CONFIDENTIAL_PRODUCTO = 'Confidencial';
export const FUNCTION_CODE_CONFIRMATION_PRODUCTO = 'Confirmacion';
export const ROUTE_TO_PRODUCTOS_PRODUCTO = 'ROUTE_TO_PRODUCTOS_PRODUCTO';
export const VALIDATE_PRODUCT_ERROR_PRODUCTO = 'VALIDATE_PRODUCT_ERROR_PRODUCTO';
export const SELECT_CHECKBOX_DEFAULT_VALUES = 'SELECT_CHECKBOX_DEFAULT_VALUES';
export const GET_GRUPOS_AFINIDAD_BY_TIPO_CUENTA = 'GET_GRUPOS_AFINIDAD_BY_TIPO_CUENTA';

/** 
 * Action que valida el nombre del producto que no sea el mismo que otro.
 * @param {any} dataProducto
 * @param {any} form
 */
export function validateAddProduct(dataProducto, form) {
    LogHelper.In(validateAddProduct.name, dataProducto, form);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        const state = getState();

        let menuProductos = state.menuProductos
        let fecha = new Date().toLocaleString()

        dataProducto.UsuarioModif = menuProductos.login;
        dataProducto.FechaUltimaModificacion = fecha

        let localValue = {
            'NOMBRE': state.producto.data.Nombre,
            'PRODUCTO_ID': state.producto.data.Id
        }
        LogHelper.Out(validateAddProduct.name, localValue, 'GET_NOMBRE_PRODUCTO_REPETIDO', "Get", 'Tarjetas', 'ADMINPRODUCTOS', 1, "Product");
        Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_NOMBRE_PRODUCTO_REPETIDO', "Get", 'Tarjetas', 'ADMINPRODUCTOS', 1, "Product");

        Engine1Proxy.Execute((data) => {
            const nombreRepetido = JSON.parse(data.GET_NOMBRE_PRODUCTO_REPETIDO).Recordset0.Rows[0].EsNombreRepetido;

            _loadValidateAddProduct(nombreRepetido, dataProducto, form);

        }, null, null, "ADMINPRODUCTOS");
    }
}

/**
 * Action que valida al guardar un producto.
 * @param {any} nombreRepetido
 * @param {any} dataProducto
 * @param {any} form
 */
function _loadValidateAddProduct(nombreRepetido, dataProducto, form) {

    LogHelper.In(_loadValidateAddProduct.name, nombreRepetido, dataProducto, form);
    if (!Array.isArray) {
        Array.isArray = function (arg) {
            return Object.prototype.toString.call(arg) === '[object Array]';
        };
    }

    let marca = _administradoraId;
    let fieldsToValidate;
    const defaultValidations = { //DICCIONARIO CON CADA VALIDACION Y SU RESPECTIVO DEFAULT OPTION Y CHECK QUE HABILITA LA OPCION SI CORRESPONDE 
        GET_ALTA_POSDATADA: ["AltaPosDatadaDefaultInterfaz", "HabilitarAltaPosDatada"],
        GET_CARTERAS: ["CarteraDefaultInterfaz"],
        GET_CATEGORIA_CAJERO: ["CategoriaCajeroDefaultInterfaz"],
        GET_CODIGO_DISTRIBUCION: ["CodigoDistribucionDefaultInterfaz", "UtilizaCodigoDistribucion"],
        GET_COMERCIALIZADORA_CANAL_VENTA_BY_ADMIN: ["ComercializadoraCanalDefaultInterfaz", "HabilitaComercializadora"],
        GET_FORMA_PAGO: ["FormaPagoDefaultInterfaz"],
        GET_GRUPO_AFINIDAD_ADMINISTRADORA: ["GrupoAfinidadDefaultInterfaz", "AsociaGrupoAfinidad"],
        GET_USO_CAJERO_AUTOMATICO: ["HabilitacionCajerosDefaultInterfaz", "UsoATM"],
        GET_ATLAS_MARCA_COMPARTIDA: ["MarcaCompartidaDefaultInterfaz", "AsociaMarcaCompartida"],
        GET_SENAL_PRE_EMISION_CABAL: ["PreEmisionDefaultInterfaz", "HabilitarSenalPreEmision"],
        GET_MODALIDAD_DISTRIBUCION_LIMITE: ["DistribucionLimiteDefaultInterfaz"],
        GET_ATLAS_HABILITACION_TARJETA: ["HabilitacionCajerosDefaultInterfaz"],
        GET_LINEA_PRESTAMO: ["LimitePrestamoDefaultInterfaz"],
        GET_MODELO_LIQUIDACION_ADMINISTRADORA: ["ModeloLiquidacionDefaultInterfaz"],
        GET_RETENCION_TARJETA_CABAL: ["RetencionTarjetaDefaultInterfaz", "HabilitarRetencionTarjeta"],
        GET_ATLAS_SEGMENTO_CARTERA: ["SegmentoCarteraDefaultInterfaz", "AsociaSegmentoCartera"],
        GET_FORMA_DEBITO: ["TipoDebitoDefaultInterfaz"],
        GET_LIMITE_COMPRA: ["LimiteCompraDefaultIntefaz"]
    }

    switch (marca) {

        case 1:
            fieldsToValidate = [
                { type: "Nombre", valid: "nombre" },
                { type: "GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA", valid: "seleccionoTipoEmpresa", marca },
                { type: "GET_SUCURSAL", valid: "seleccionoSucursal" },
                { type: "GET_GRUPO_AFINIDAD_ADMINISTRADORA", valid: "seleccionoGrupoAfinidad", default: "GrupoAfinidadDefaultId", hasCondition: true },
                { type: "GET_DENOMINACION_CUARTA_LINEA", valid: "seleccionoDenominacionCuartaLinea", hasCondition: true },
                { type: "GET_TEXTO_CUARTA_LINEA", valid: "hayTextoCuartaLinea", hasCondition: true },
                { type: "GET_CODIGO_DISTRIBUCION", valid: "seleccionoCodigoDistribucion", default: "CodigoDistribucionDefaultId", hasCondition: true },
                { type: "GET_COMERCIALIZADORA_CANAL_VENTA_BY_ADMIN", valid: "seleccionoComercializadora", default: "ComercializadoraCanalDefaultIdFront", hasCondition: true },
                { type: "GET_ATLAS_TIPO_COMUNICACION", valid: "seleccionoCorrespondencia" },

                { type: "GET_INGRESO_SOLICITUDES", valid: "seleccionoIngresoSolicitudes" },
                { type: "CostoEmision", valid: "seleccionoCostoEmision", hasCondition:true },
                { type: "cargoEnCuotas", valid: "rangoCargoCuotas", hasCondition:true },
                { type: "PorcBonificacionEmision", valid: "porcBonificacionEmision", hasCondition:true },

                { type: "GET_FUNCIONAMIENTO_LIMITES", valid: "seleccionoFuncionamientoLimites" },
                { type: "GET_MODALIDAD_DISTRIBUCION_LIMITE", valid: "seleccionoModeloDistribucion", default: "DistribucionLimiteDefaultId" },
                { type: "GET_LIMITE_COMPRA", valid: "seleccionoLimiteCompra", default: "LimiteCompraDefaultId", hasCondition: true },
                { type: "FLCCxCuenta", valid: "seleccionoFactorLimiteCompra", hasCondition: true },
                { type: "GET_LINEA_PRESTAMO", valid: "seleccionoLineaPrestamo", default: "LimitePrestamoDefaultId",hasCondition:true },

                { type: "LimiteFinanciacionxCuenta", valid: "seleccionoLimiteFinanciacion", hasCondition: true },
                { type: "GET_CARTERAS", valid: "seleccionoCartera", default: "CarteraDefaultId",hasCondition:true },
                { type: "GET_MODELO_LIQUIDACION_ADMINISTRADORA", valid: "seleccionoModeloLiquidacion", default: "ModeloLiquidacionDefaultId" },
                { type: "GET_CATEGORIA_CAJERO", valid: "seleccionoCategoria", default: "CategoriaCajeroDefaultId", hasCondition: true },
                { type: "GET_ATLAS_HABILITACION_TARJETA", valid: "seleccionoTarjetaCajeroAutomatico", default: "HabilitacionCajerosDefaultId", hasCondition: true },
                { type: "GET_USO_CAJERO_AUTOMATICO", valid: "seleccionoCajeroAutomatico", hasCondition: true },

                { type: "GET_FORMA_PAGO", valid: "seleccionoFormaPago", default: "FormaPagoDefaultId" },
                { type: "GET_FORMA_DEBITO", valid: "seleccionoFormaPagoDebito", default: "TipoDebitoDefaultId", hasCondition: true },
                { type: "LimiteCompraMaximo", valid: "seleccionoLimiteInput", hasCondition: true }
            ];
            break;
        case 2:
            fieldsToValidate = [
                { type: "Nombre", valid: "nombre" },
                { type: "GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA", valid: "seleccionoTipoEmpresa", hasCondition:true},
                { type: "GET_SUCURSAL", valid: "seleccionoSucursal" },
                { type: "GET_GRUPO_AFINIDAD_ADMINISTRADORA", valid: "seleccionoGrupoAfinidad", default: "GrupoAfinidadDefaultId", hasCondition: true },

                { type: "GET_DENOMINACION_CUARTA_LINEA", valid: "seleccionoDenominacionCuartaLinea", hasCondition: true },
                { type: "GET_TEXTO_CUARTA_LINEA", valid: "hayTextoCuartaLinea", hasCondition: true },
                
                { type: "GET_ATLAS_MARCA_COMPARTIDA", valid: "seleccionoMarcaCompartida", default: "MarcaCompartidaDefaultId", hasCondition: true },
                { type: "GET_ATLAS_SEGMENTO_CARTERA", valid: "seleccionoSegmentoCartera", default: "SegmentoCarteraDefaultId", hasCondition: true },
                { type: "GET_ATLAS_TIPO_COMUNICACION", valid: "seleccionoCorrespondencia" },

                { type: "LimiteFinanciacionCabal", valid: "limiteFinanciacionCabal", hasCondition: true },
                { type: "establecerPorCuenta", valid: "topePagoMinimoCabal", hasCondition: true },
                { type: "GET_CARTERAS", valid: "seleccionoCartera", default: "CarteraDefaultId" },

                { type: "GET_INGRESO_SOLICITUDES", valid: "seleccionoIngresoSolicitudes" },
                { type: "rangoCoeficienteDefault", valid: "seleccionoRangoCoeficiente", hasCondition: true },
                { type: "GET_ALTA_POSDATADA", valid: "seleccionoAltaPosDatada", default: "AltaPosDatadaDefaultId", hasCondition: true },
                { type: "GET_RETENCION_TARJETA_CABAL", valid: "seleccionoRetencionTarjeta", default: "RetencionTarjetaDefaultId", hasCondition: true },
                { type: "GET_SENAL_PRE_EMISION_CABAL", valid: "seleccionoPreEmision", default: "PreEmisionDefaultId", hasCondition: true },

                { type: "GET_FORMA_PAGO", valid: "seleccionoFormaPago", default: "FormaPagoDefaultId"},
                { type: "GET_FORMA_DEBITO", valid: "seleccionoFormaPagoDebito", default: "TipoDebitoDefaultId", hasCondition: true },
                { type: "limiteCompraCabal", valid: "limiteCompraCabalMax", hasCondition: true },

            ];
            break;
        default:
    }

    const valids = [];


    const validateResult = (element) => {
        if (Array.isArray(element)) {
            if(element[0] && element[0].hasOwnProperty("Activo")){
                return element.some(d => d.Checked && d.Activo && !d.noDisponible);
            }else{
                return element.some(d => d.Checked);
            }
        } else {
            return !([null, 0, "",undefined].some(s => s === element));
        }
    }

    fieldsToValidate.forEach(f => {
        let result = false;

        if (f.hasCondition) {
            switch (f.type) {
                case"GET_LINEA_PRESTAMO":{
                    if(dataProducto.GET_PARAMETRO_GENERAL.SINOLINEAPRESTAMOS == true){
                        result = validateResult(dataProducto[f.type])
                    }else{
                        dataProducto.LimitePrestamoDefaultInterfaz = false
                        result = true
                    }
                    break
                }
                case "cargoEnCuotas":{
                    if (dataProducto.CostoEmision != "SC" && dataProducto.CargoEnCuotas){
                        let cargoEnCuotasDesde = parseInt(dataProducto.CargoEnCuotasDesde);
                        let cargoEnCuotasHasta = parseInt(dataProducto.CargoEnCuotasHasta);
                        let cuotasDefault = parseInt(dataProducto.CuotasDefault);
                        
                        if(!isNaN(cargoEnCuotasDesde) && !isNaN(cargoEnCuotasHasta) && !isNaN(cuotasDefault) ){
                            result = (cargoEnCuotasDesde <= cargoEnCuotasHasta && cuotasDefault >= cargoEnCuotasDesde && cuotasDefault <= cargoEnCuotasHasta)
                        }else{
                            result = false;
                        }
                    }else{
                        result = true;
                    }
                    break
                }
                case "PorcBonificacionEmision":{
                    if (dataProducto.CostoEmision == "BP"){
                        let bonifDesde = parseInt(dataProducto.PorcBonificacionEmisionDesde);
                        let bonifHasta = parseInt(dataProducto.PorcBonificacionEmisionHasta);
                        let bonifDefault = parseInt(dataProducto.BonificacionEmisionDefault);
                        
                        if(!isNaN(bonifDesde) && !isNaN(bonifHasta) && !isNaN(bonifDefault) ){
                            result = (bonifDesde <= bonifHasta && bonifDefault >= bonifDesde && bonifDefault <= bonifHasta)
                        }else{
                            result = false;
                        }
                    }else{
                        result = true;
                    }
                    break
                }
                case "GET_SENAL_PRE_EMISION_CABAL": {
                    if (dataProducto.HabilitarSenalPreEmision) { //PRIMERA CONDICION QUE SE HAYA HABILITADO LA SEÑAL DE PREEMISION
                        let preemisionSelected = dataProducto[f.type].filter(c => c.Checked) // COMERCIALIZADORA SELECCIONADA
                        if (preemisionSelected.length > 0) { //SI EFECTIVAMENTE HAY UNA SELECCIONADA SE SIGUE VALIDANDO, SINO DA FALSE
                            const existePreEmisionRadio = dataProducto.GET_SENAL_PRE_EMISION_CABAL.some(x => x.Id == 2 && x.Checked);

                            if (existePreEmisionRadio) {
                                result = dataProducto.GET_PRE_EMISION_CABAL.some(c => c.Checked);
                            } else {
                                result = true;
                            }

                        } else {
                            result = false;
                        }
                    } else {
                        result = true;
                    }
                    break;
                }
                case "GET_COMERCIALIZADORA_CANAL_VENTA_BY_ADMIN": {
                    if (dataProducto.HabilitaComercializadora) { 
                        let flag = true
                        let comSelected = dataProducto[f.type].filter(c => c.Checked) 
                        comSelected.map(comercializadora=>{
                            if(!comercializadora.CanalVentas.some(canal=>canal.Checked)) flag = false
                        })
                        result = flag
                    } else {
                        result = true
                    }
                    break;
                }
                case "CostoEmision":{
                    if(dataProducto.TipoProductoEmpInd =="E"){
                        result=true
                    }else{
                        result = validateResult(dataProducto[f.type])
                    }
                    break;
                }
                case "GET_ATLAS_MARCA_COMPARTIDA": {
                    if (dataProducto.AsociaMarcaCompartida) {
                        result = validateResult(dataProducto[f.type])
                    } else {
                        result = true
                    }
                    break;
                }
                case "GET_GRUPO_AFINIDAD_ADMINISTRADORA": {
                    if (dataProducto.AsociaGrupoAfinidad) {
                        result = validateResult(dataProducto[f.type])
                    } else {
                        result = true
                    }
                    break;
                }
                case "GET_ATLAS_SEGMENTO_CARTERA": {
                    if (dataProducto.AsociaSegmentoCartera) {
                        result = validateResult(dataProducto[f.type])

                    } else {
                        result = true
                    }
                    break;
                }
                case "GET_ALTA_POSDATADA": {
                    if (dataProducto.HabilitarAltaPosDatada) {
                        result = dataProducto[f.type].some(c => c.Checked)

                            ;
                    } else {
                        result = true
                    }
                    break;
                }
                case "GET_RETENCION_TARJETA_CABAL": {
                    if (dataProducto.HabilitarRetencionTarjeta) {
                        result = dataProducto[f.type].some(c => c.Checked)

                            ;
                    } else {
                        result = true
                    }
                    break;
                }
                case "GET_CATEGORIA_CAJERO":{
                    if (dataProducto.GET_PARAMETRO_GENERAL.SINOREDBANELCO) {
                        result = validateResult(dataProducto[f.type])
                    }else{
                        result = true
                    }
                    break;
                }
                case "GET_ATLAS_HABILITACION_TARJETA":{
                    if (dataProducto.GET_PARAMETRO_GENERAL.SINOREDBANELCO) {
                        result = validateResult(dataProducto[f.type])
                    }else{
                        result = true
                    }
                    break;
                }
                case "GET_USO_CAJERO_AUTOMATICO": {
                    if (dataProducto.GET_PARAMETRO_GENERAL.SINOREDBANELCO) {
                        result = validateResult(dataProducto[f.type])
                    }else{
                        result = true
                    }
                    break;
                }
                case "LimiteFinanciacionxCuenta": {
                    if (!dataProducto.LimiteFinanciacionxCuenta) {

                        result = true
                    }
                    else {
                        if (dataProducto[f.type]) {
                            result = (!isNaN(parseInt(dataProducto.LimiteFinanciacionDesde))
                                && !isNaN(parseInt(dataProducto.LimiteFinanciacionHasta)))
                            //&& !isNaN(parseInt(dataProducto.LimiteFinanciacionDefault)));

                            if (result) {
                                const desde = parseInt(dataProducto.LimiteFinanciacionDesde);
                                const hasta = parseInt(dataProducto.LimiteFinanciacionHasta);
                                const limiteDefault = parseInt(dataProducto.LimiteFinanciacionDefault);

                                result = (desde <= hasta && desde >= 0)

                                if (result) {
                                    result = (hasta <= 100);

                                    if (result) {
                                        result = (limiteDefault >= desde && limiteDefault <= hasta);
                                    }
                                }
                            }

                        }
                    }

                    break;
                }
                case "GET_CARTERAS":{
                    if(dataProducto.TipoProductoEmpInd =="I"){
                        result = validateResult(dataProducto[f.type])
                    }else {
                        result=true
                    }
                    break;
                }
                case "LimiteFinanciacionCabal": {
                    result = (!isNaN(parseInt(dataProducto.limiteFinanciacionCabalMin))
                        && !isNaN(parseInt(dataProducto.limiteFinanciacionCabalMax))
                        && !isNaN(parseInt(dataProducto.limiteFinanciacionCabalDefault)));

                    if (result) {
                        const min = parseInt(dataProducto.limiteFinanciacionCabalMin);
                        const max = parseInt(dataProducto.limiteFinanciacionCabalMax);
                        const lfDefault = parseInt(dataProducto.limiteFinanciacionCabalDefault);

                        result = (min <= max && min >= 0)

                        if (result) {
                            result = (max < 1000000000);

                            if (result) {
                                result = (lfDefault >= min && lfDefault <= max);
                            }
                        }
                    }
                    break;
                }
                case "establecerPorCuenta": {

                    if (dataProducto[f.type]) {
                        result = (!isNaN(parseInt(dataProducto.topePagoMinimoCabalMin))
                            && !isNaN(parseInt(dataProducto.topePagoMinimoCabalMax))
                            && !isNaN(parseInt(dataProducto.topePagoMinimoCabalDefault)));

                        if (result) {
                            const min = parseInt(dataProducto.topePagoMinimoCabalMin);
                            const max = parseInt(dataProducto.topePagoMinimoCabalMax);
                            const tpmDefault = parseInt(dataProducto.topePagoMinimoCabalDefault);

                            result = (min <= max && min >= 0)

                            if (result) {
                                if (result) {
                                    result = (tpmDefault >= min && tpmDefault <= max);
                                }
                            }
                        }
                    }else{
                        result = true
                    }
                    break;
                }
                case "rangoCoeficienteDefault": {
                    if (dataProducto[f.type] != null) {
                        result = (!isNaN(parseFloat(dataProducto.rangoCoeficienteMax)) && (!isNaN(parseFloat(dataProducto.rangoCoeficienteMin)))&& (!isNaN(parseFloat(dataProducto.rangoCoeficienteDefault))));
                        
                        if (result) {
                            const min = parseFloat(dataProducto.rangoCoeficienteMin);
                            const max = parseFloat(dataProducto.rangoCoeficienteMax);
                            const tpmDefault = parseFloat(dataProducto.rangoCoeficienteDefault);

                            result = (min <= max && min >= 0)

                            if (result) {
                                if (result) {
                                    result = (tpmDefault >= min && tpmDefault <= max);
                                }
                            }
                        }
                    }
                    break;
                }
                case "FLCCxCuenta": {
                    if (dataProducto[f.type]) {
                        result = (!isNaN(parseInt(dataProducto.FLCCDesde))
                            && !isNaN(parseInt(dataProducto.FLCCHasta)));

                        if (result) {
                            const desde = parseInt(dataProducto.FLCCDesde);
                            const hasta = parseInt(dataProducto.FLCCHasta);
                            const def = parseInt(dataProducto.FLCCDefault);

                            result = (desde <= hasta && desde >= 0 && def >= desde && def <= hasta)

                            if (result) {
                                result = (hasta < 10);
                            }
                        }
                    }else{
                        result=true
                    }
                    break;
                }
                case "GET_LIMITE_COMPRA": {
                    const tipoCuenta = dataProducto.GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA.find(item => item.Checked);
                    if (tipoCuenta && (tipoCuenta.TipoLimite == "M")) {
                        result = true
                        f.esMonto = true
                    }else{
                        let arr = dataProducto.GET_LIMITE_COMPRA.filter(l=>l.Checked)
                        result = arr.length>0
                    }
                    break;
                }
                case "GET_DENOMINACION_CUARTA_LINEA": {
                    if (dataProducto.GET_PARAMETRO_GENERAL.SINODENOMINACIONCUARTALINEA && dataProducto.HabilitaCuartaLinea) {
                        result = validateResult(dataProducto[f.type])
                    } else {
                        result = true;
                    }
                    break;
                }
                case "GET_TEXTO_CUARTA_LINEA": {
                    if (!dataProducto.TextoCuartaLinea && dataProducto.TipoGrabadoCuartaLinea == "Texto") {
                        result = false
                    } else {
                        result = true;
                    }
                    break;
                }
                case "GET_CODIGO_DISTRIBUCION": {
                    if (dataProducto.UtilizaCodigoDistribucion) {
                        result = validateResult(dataProducto[f.type])
                    } else {
                        result = true
                    }
                    break;
                }
                case "GET_FORMA_DEBITO": {
                    const existsDebitoEnCuenta = dataProducto.GET_FORMA_PAGO.some(c => c.Checked && c.EsDebitoEnCuenta);
                    if (existsDebitoEnCuenta) {
                        result = validateResult(dataProducto[f.type]);
                    } else {
                        result = true
                    }
                    break;
                }
                case "LimiteCompraMaximo": {
                    
                    const tipoCuenta = dataProducto.GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA.find(item => item.Checked);
                    if (tipoCuenta && tipoCuenta.TipoLimite == "M") {
                        
                        result = !([null, 0, ""].some(s => s == dataProducto[f.type]));

                        if(result){
                            if(dataProducto.GET_PARAMETRO_GENERAL.MONEDALIMITECOMPRA=="P" || dataProducto.GET_PARAMETRO_GENERAL.MONEDALIMITECOMPRA=="A" ){
                                let limiteMinimoPeso = tipoCuenta.LimiteMinimoCompraPeso
                                result = parseInt(dataProducto[f.type]) >= parseInt(limiteMinimoPeso) 
                            }else if(dataProducto.GET_PARAMETRO_GENERAL.MONEDALIMITECOMPRA=="D"){
                                let limiteMinimoDolar = tipoCuenta.LimiteMinimoCompraDolar
                                result = parseInt(dataProducto[f.type]) >= parseInt(limiteMinimoDolar)
                            }
                        }
                    } else {
                        result = true
                    }
                    break;
                }
                case "limiteCompraCabal":{
                    const limMin = parseInt(dataProducto.limiteCompraCabalMin)
                    const limMax = parseInt(dataProducto.limiteCompraCabalMax)
                    const limDefault = parseInt(dataProducto.limiteCompraCabalDefault) 

                    result = ((limMin != NaN && limMax != NaN && limDefault != NaN) && (limMin<=limMax) && (limDefault >= limMin && limDefault <= limMax));
                    break;
                }
                case "GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA":{
                    //solo valida para cabal
                    result=true
                    break;
                }
            } //cierro el switch
        } //cierro el if f.hascondition; 
        else {
            result = validateResult(dataProducto[f.type])
        }
        if (result) { //SI LA VALIDACION ANTERIOR DIO TRUE, REVISA QUE DE HABERSE TILDADO LA OPCION DEFAULT SE HAYA SELECCIONADO UNA 
            if(f.type != "GET_LIMITE_COMPRA" && f.type != "GET_CATEGORIA_CAJERO" && f.type != "GET_ATLAS_HABILITACION_TARJETA" && f.type != "GET_FORMA_DEBITO" && f.type != "GET_CARTERAS" ){
                if (f.hasOwnProperty("default")) {
                    if (f.hasCondition) {
                        if (defaultValidations[f.type].length > 1) {
                            let habilita = defaultValidations[f.type][1]
                            let def = defaultValidations[f.type][0]
                            if (dataProducto[habilita] == true && dataProducto[def] == true) {
                                result = !([null, 0, ""].some(s => s == dataProducto[f.default]));
                                if(result && Array.isArray(dataProducto[f.type])){
                                    result = dataProducto[f.type].some(e=>e.Id == dataProducto[f.default] && e.Checked || f.default == "ComercializadoraCanalDefaultIdFront")
                                }
                            }
                        } else {
                            let def = defaultValidations[f.type][0]
                            if (dataProducto[def] == true) {
                                result = !([null, 0, ""].some(s => s == dataProducto[f.default]));
                                if(result && Array.isArray(dataProducto[f.type])){
                                    result = dataProducto[f.type].some(e=>e.Id == dataProducto[f.default] && e.Checked || f.esMonto )
                                }
                            }
                        }
                    } else {
                        let def = defaultValidations[f.type][0]
                        if (dataProducto[def] == true) {
                            result = !([null, 0, ""].some(s => s == dataProducto[f.default]));
                            if(result && Array.isArray(dataProducto[f.type])){
                                result = dataProducto[f.type].some(e=>e.Id == dataProducto[f.default] && e.Checked)
                            }
                        }
                    }
                }
            }else{
                if(f.type == "GET_FORMA_DEBITO"){
                    let debitoEnCuenta = dataProducto.GET_FORMA_PAGO.some(c => c.Checked && c.EsDebitoEnCuenta);
                    let formaPagoDefault = dataProducto.FormaPagoDefaultId
                    let formaPagoDefaultEsDebito = dataProducto.GET_FORMA_PAGO.some(forma=>forma.Id==formaPagoDefault && forma.EsDebitoEnCuenta)

                    if(debitoEnCuenta && formaPagoDefaultEsDebito){
                        let def = defaultValidations[f.type][0]
                            if (dataProducto[def] == true) {
                                result = !([null, 0, ""].some(s => s == dataProducto[f.default]));
                                if(result && Array.isArray(dataProducto[f.type])){
                                    result = dataProducto[f.type].some(e=>e.Id == dataProducto[f.default] && e.Checked)
                                }
                            }
                    }else{
                        result = true
                    }
                    
                }else if(f.type == "GET_CARTERAS"){
                    if(dataProducto.TipoProductoEmpInd =="E"){
                        result = true
                    }else{
                        result = dataProducto.GET_CARTERAS.some(c=>c.Checked)
                    }
                    
                }else if(f.type == "GET_LIMITE_COMPRA"){
                    if(dataProducto.GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA.find(item => item.Checked && item.TipoLimite=="M")){
                        result = true
                    }else if(dataProducto.GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA.find(item => item.Checked && item.TipoLimite=="L")){
                        if (dataProducto.LimiteCompraDefaultIntefaz){
                            result = dataProducto.LimiteCompraDefaultId > 0
                        }else{
                            result = true
                        }
                    }
                }else{
                    if(dataProducto.GET_PARAMETRO_GENERAL.SINOREDBANELCO){
                        if (defaultValidations[f.type] && defaultValidations[f.type].length > 1) {
                            let habilita = defaultValidations[f.type][1]
                            let def = defaultValidations[f.type][0]
                            if (dataProducto[habilita] == true && dataProducto[def] == true) {
                                result = !([null, 0, ""].some(s => s == dataProducto[f.default]));
                                if(result && Array.isArray(dataProducto[f.type])){
                                    result = dataProducto[f.type].some(e=>e.Id == dataProducto[f.default] && e.Checked)
                                }
                            }
                        } else {
                            let def = defaultValidations[f.type] && defaultValidations[f.type][0]
                            if (dataProducto[def] == true) {
                                result = !([null, 0, ""].some(s => s == dataProducto[f.default]));
                                if(result && Array.isArray(dataProducto[f.type])){
                                    result = dataProducto[f.type].some(e=>e.Id == dataProducto[f.default] && e.Checked)
                                }
                            }
                        }
                    }
                }
            }           
        }
        
        dataProducto.ERROR_PRODUCT[f.valid] = result
        valids.push(result);
    });//cierro forEach

    dataProducto.ERROR_PRODUCT["nombreRepetido"] = (nombreRepetido == 0);
    valids.push(nombreRepetido == 0);

    const validate = !valids.some(v => v == false);

    if (validate) {
        if (!dataProducto.CargoEnCuotas) {
            dataProducto.CargoEnCuotasDesde = null;
            dataProducto.CargoEnCuotasHasta = null;
        }

        if (!dataProducto.FLCCxCuenta) {
            dataProducto.FLCCDesde = null;
            dataProducto.FLCCHasta = null;
        }

        if (!dataProducto.LimiteFinanciacionxCuenta) {
            dataProducto.LimiteFinanciacionDesde = null;
            dataProducto.LimiteFinanciacionHasta = null;
        }

        if (dataProducto.LimiteCompraMaximo == "") {
            dataProducto.LimiteCompraMaximo = null;
        }
        

        ProductoManager.GuardarProducto(dataProducto, SagasHelper.GetSagasId, ejecutarPorEstado);
        _dispatch({ type: READY_REQUEST_PRODUCTO });
    } else {
        _dispatch({ type: VALIDATE_PRODUCT_ERROR_PRODUCTO, error: dataProducto.ERROR_PRODUCT });
    }
}


/** 
 * Action que obtiene el estado inicial.
 * @param {any} state
 * @param {any} currentScope
 */
export function resetState() {
    LogHelper.In(resetState.name);

    return (dispatch) => {
        dispatch({ type: INITIAL_STATE_PRODUCTO });
    }
}

/** 
 * Action que obtiene el estado inicial.
 * @param {any} state
 * @param {any} currentScope
 */
export function getScreenData(state, currentScope) {
    LogHelper.In(getScreenData.name, state, currentScope);

    _productoId = JSON.parse(state);
    _administradoraId = 1;
    
    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: GET_SCREEN_DATA_PRODUCTO, state });

        var currentScopeRequest = {
            "UserId": currentScope.UserId,
            "ProductCode": currentScope.ProductCode,
            "ProgramCode": currentScope.ProgramCode
        }

        ConciergeProxy.Execute((data) => _loadScreenData(data), null, "GETFUNCTIONS", currentScopeRequest);
    }
}

/**
 * 
 */
export function routeToPrevious() {
    LogHelper.In(routeToPrevious.name);

    return (dispatch) => {
        _routing(null, ROUTE_TO_PRODUCTOS_PRODUCTO, dispatch);
    }
}

/* Fin routting */

/* FUNCIONES PARA EL SELECTOR DE SUCURSALES */
/**
 * 
 */
export function showMoreBranches() {
    LogHelper.In(showMoreBranches.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: SHOW_MORE_BRANCHES_PRODUCTO });
    }

}

/**
 * 
 */
export function noSucursalSelected() {
    LogHelper.In(noSucursalSelected.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: NO_SUCURSAL_SELECTED_PRODUCTO });
    }
}

/**
 * 
 */
export function noSeleccionAmbasReglasAvanzadas() {
    LogHelper.In(noSeleccionAmbasReglasAvanzadas.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: NO_SELECCION_AMBAS_REGLAS_AVANZADAS_PRODUCTO });
    }
}

/**
 * 
 */
export function errorSave() {
    LogHelper.In(errorSave.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: ERROR_SAVE_PRODUCTO });
    }

}

/**
 * 
 */
export function showLessBranches() {
    LogHelper.In(showLessBranches.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: SHOW_LESS_BRANCHES_PRODUCTO });
    }

}

/**
 * 
 * @param {any} branches
 */
export function saveSelectedBranches(branches, componente) {
    LogHelper.In(saveSelectedBranches.name, branches, componente);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: SAVE_SELECTED_BRANCHES_PRODUCTO, branches: branches, componente: componente });
    }
}

/**
 * 
 */
export function cancelSelectedBranches(componente) {
    LogHelper.In(cancelSelectedBranches.name, componente);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: CANCEL_SELECTED_BRANCHES_PRODUCTO, componente: componente });
    }
}

/**
 * 
 * @param {any} branchId
 */
export function removeSelectedBranch(branchId, componente) {
    LogHelper.In(removeSelectedBranch.name, branchId, componente);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: REMOVE_SELECTED_BRANCH_PRODUCTO, branchId: branchId, componente: componente });
    }
}
/* FIN FUNCIONES PARA EL SELECTOR DE SUCURSALES */

/* FUNCIONES PARA EL SELECTOR DE LIMITES DE COMPRA */
/**
 * 
 */
export function showMorePurchaseLimits() {
    LogHelper.In(showMorePurchaseLimits.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: SHOW_MORE_PURCHASE_LIMITS_PRODUCTO });
    }
}

/**
 * 
 */
export function showLessPurchaseLimits() {
    LogHelper.In(showLessPurchaseLimits.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: SHOW_LESS_PURCHASE_LIMITS_PRODUCTO });
    }
}

/**
 * 
 * @param {any} LimiteCompraList
 */
export function saveSelectedPurchaseLimits(LimiteCompraList) {
    LogHelper.In(saveSelectedPurchaseLimits.name, LimiteCompraList);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: SAVE_SELECTED_PURCHASE_LIMITS_PRODUCTO, purchaseLimits: LimiteCompraList });
    }
}

/**
 * 
 */
export function cancelSelectedPurchaseLimits() {
    LogHelper.In(cancelSelectedPurchaseLimits.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: CANCEL_SELECTED_PURCHASE_LIMITS_PRODUCTO });
    }
}

/**
 * 
 * @param {any} purchaseLimitId
 */
export function removeSelectedPurchaseLimit(purchaseLimitId) {
    LogHelper.In(removeSelectedPurchaseLimit.name, purchaseLimitId);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: REMOVE_SELECTED_PURCHASE_LIMIT_PRODUCTO, purchaseLimitId: purchaseLimitId });
    }
}
/* FIN FUNCIONES PARA EL SELECTOR DE LIMITES DE COMPRA */

/* FUNCIONES DE GUARDADO Y CANCELAR GENERALES DE LA PANTALLA */

/**
 * 
 * @param {any} dispatch
 */
export function cancelProduct(dispatch) {
    LogHelper.In(cancelProduct.name, dispatch);

    return (dispatch) => {
        _routing(null, ROUTE_TO_PRODUCTOS_PRODUCTO, dispatch);
    }
}

/**
 * 
 */
export function finishProduct() {
    LogHelper.In(finishProduct.name);

    return (dispatch) => {
        $('.modal').modal('hide');
        _routing(null, ROUTE_TO_PRODUCTOS_PRODUCTO, dispatch);
    }

}
/* FIN FUNIONES DE GUARDADO Y CANCELAR GENERALES DE LA PANTALLA */

/* FUNCIONES PARA REGLAS AVANZADAS */
/**
 * 
 * @param {any} tabla
 * @param {any} advancedRuleId
 * @param {any} optionsType
 */
export function getOptionsByField(tabla, advancedRuleId, optionsType) {
    LogHelper.In(getOptionsByField.name, tabla, advancedRuleId, optionsType);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        let localValue = {
            'TABLA': tabla
        }
        LogHelper.Out(getOptionsByField.name, localValue, 'GET_PRODUCTO_OPCION_CAMPO', "Get", 'Tarjetas', 'ADMINPRODUCTOS', 1, "Product");
        Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_PRODUCTO_OPCION_CAMPO', "Get", 'Tarjetas', 'ADMINPRODUCTOS', 1, "Product");
        Engine1Proxy.Execute((data) => _loadOptionsByFieldData(data, tabla, advancedRuleId, optionsType), null, null, "ADMINPRODUCTOS");
    }
}

/**
 * 
 * @param {any} newAdvancedRule
 */
export function addAdvancedRule(newAdvancedRule) {
    LogHelper.In(addAdvancedRule.name, newAdvancedRule);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: ADD_ADVANCED_RULE_PRODUCTO, newAdvancedRule: newAdvancedRule });
    }
}

/**
 * 
 * @param {any} advancedRuleId
 */
export function removeAdvancedRule(advancedRuleId) {
    LogHelper.In(removeAdvancedRule.name, advancedRuleId);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: REMOVE_ADVANCED_RULE_PRODUCTO, advancedRuleId: advancedRuleId });
    }
}

/**
 * 
 * @param {any} newAdvancedRule
 */
export function duplicateAdvancedRule(newAdvancedRule) {
    LogHelper.In(duplicateAdvancedRule.name, newAdvancedRule);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: DUPLICATE_ADVANCED_RULE_PRODUCTO, newAdvancedRule: newAdvancedRule });
    }
}

/**
 * 
 * @param {any} newAdvancedRule
 * @param {any} optionsType
 */
export function saveSelectedOptions(newAdvancedRule, optionsType) {
    LogHelper.In(saveSelectedOptions.name, newAdvancedRule, optionsType);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: SAVE_PRE_POST_OPTIONS_PRODUCTO, newAdvancedRule: newAdvancedRule, optionsType: optionsType });
    }
}

/**
 * 
 * @param {any} advancedRuleId
 * @param {any} optionId
 * @param {any} optionsType
 */
export function removeSelectedOption(advancedRuleId, optionId, optionsType) {
    LogHelper.In(removeSelectedOption.name, advancedRuleId, optionId, optionsType);

    return (dispatch) => {
        dispatch({ type: REMOVE_PRE_POST_SELECTED_OPTION_PRODUCTO, advancedRuleId: advancedRuleId, optionId: optionId, optionsType: optionsType });
    }
}

/* FIN FUNCIONES PARA REGLAS AVANZADAS */
/**
 * 
 * @param {any} list
 * @param {any} item
 */
export function selectCheckBox(list, item, params) {
    LogHelper.In(selectCheckBox.name, list, item, params);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: SELECT_CHECKBOX_PRODUCTO, list, item, params });
    }
}
/**
 * Dispacha un evento para al selección o deselección de checks por defecto
 * @param {any} prop Nombre del campo a actualizar
 * @param {any} value Valor del campo a actualizar
 */
export function selectCheckboxDefault(prop, value) {
    LogHelper.In(selectCheckboxDefault.name, prop, value);

    return (dispatch) => {
        dispatch({ type: SELECT_CHECKBOX_DEFAULT_VALUES, prop, value });
    }
}

/**
 * 
 * @param {any} action
 * @param {any} id
 */
export function selectCombo(action, id) {
    LogHelper.In(selectCombo.name, action, id);

    return (dispatch) => {
        dispatch({ type: SELECT_COMBO_PRODUCTO, action: action, id: id });
    }
}

/**
 * 
 * @param {any} action
 * @param {any} value
 */
export function changeInput(action, value) {
    LogHelper.In(changeInput.name, action, value);

    return (dispatch) => {
        dispatch({ type: CHANGE_INPUT_PRODUCTO, action: action, value: value });
    }
}

/**
 * 
 * @param {any} list
 * @param {any} item
 */
export function selectRadio(list, item, params) {

    LogHelper.In(selectRadio.name, list, item, params);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: SELECT_RADIO_PRODUCTO, list: list, item: item, params });
    }
}

//OBTENCIÓN DE INFORMACIÓN A PARTIR DEL ID DE LA ADMINISTRADORA SELECCIONADA
/**
 * 
 * @param {any} administratorId
 * @param {any} administradoraAbreviatura
 */
export function getDataByAdministratorId(administratorId, administradoraAbreviatura) {
    LogHelper.In(getDataByAdministratorId.name, administratorId, administradoraAbreviatura);
    _administradoraId = administratorId;
    return (dispatch, getState) => {
        //LOCALVALUE
        let localValue = {
            'ADMINISTRADORA_ID': administratorId
        };
        let paramsGetDatosProductoById = {
            'PRODUCTO_ID': _productoId
        }
        
        //GET_PARAMETRO_GENERAL
        LogHelper.Out(getDataByAdministratorId.name, localValue, 'GET_PARAMETRO_GENERAL', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_PARAMETRO_GENERAL', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

        //GET_ALTA_PRODUCTO_CABAL
        LogHelper.Out(getDataByAdministratorId.name, localValue, 'GET_ALTA_PRODUCTO_CABAL', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_ALTA_PRODUCTO_CABAL', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

        //GET_SUCURSAL
        LogHelper.Out(getDataByAdministratorId.name, localValue, 'GET_SUCURSAL', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_SUCURSAL', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

        //GET_MODELO_LIQUIDACION_ADMINISTRADORA
        LogHelper.Out(getDataByAdministratorId.name, localValue, 'GET_MODELO_LIQUIDACION_ADMINISTRADORA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_MODELO_LIQUIDACION_ADMINISTRADORA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

        //GET_GRUPO_AFINIDAD_ADMINISTRADORA
        LogHelper.Out(getDataByAdministratorId.name, localValue, 'GET_GRUPO_AFINIDAD_ADMINISTRADORA_ACTIVOS', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_GRUPO_AFINIDAD_ADMINISTRADORA_ACTIVOS', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        
        //GET_GRUPO_AFINIDAD_ADMINISTRADORA PARA MODIFICACION DE PRODUCTO GUARDADO (FILTRA POR TIPO DE PRODUCTO)
        LogHelper.Out(getDataByAdministratorId.name, paramsGetDatosProductoById, 'GET_ATLAS_GRUPOS_AFINIDAD_BY_ID_PRODUCTO', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramsGetDatosProductoById, 'GET_ATLAS_GRUPOS_AFINIDAD_BY_ID_PRODUCTO', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

        //GET_LIMITE_COMPRA
        LogHelper.Out(getDataByAdministratorId.name, localValue, 'GET_LIMITE_COMPRA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_LIMITE_COMPRA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

        //GET_CARTERAS
        LogHelper.Out(getDataByAdministratorId.name, localValue, 'GET_CARTERAS', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_CARTERAS', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

        ////GET_AGRUPAMIENTO
        //LogHelper.Out(getDataByAdministratorId.name, localValue, 'GET_AGRUPAMIENTO', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        //Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_AGRUPAMIENTO', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

        //GET_LINEA_PRESTAMO
        LogHelper.Out(getDataByAdministratorId.name, localValue, 'GET_LINEA_PRESTAMO', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_LINEA_PRESTAMO', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

        //GET_CATEGORIA_CAJERO
        LogHelper.Out(getDataByAdministratorId.name, localValue, 'GET_CATEGORIA_CAJERO', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_CATEGORIA_CAJERO', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

        //GET_CODIGO_DISTRIBUCION
        LogHelper.Out(getDataByAdministratorId.name, localValue, 'GET_CODIGO_DISTRIBUCION', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_CODIGO_DISTRIBUCION', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

        //GET_FORMA_PAGO
        LogHelper.Out(getDataByAdministratorId.name, localValue, 'GET_FORMA_PAGO', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_FORMA_PAGO', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

        //GET_FORMA_DEBITO
        LogHelper.Out(getDataByAdministratorId.name, localValue, 'GET_FORMA_DEBITO', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_FORMA_DEBITO', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

        //GET_MODALIDAD_DISTRIBUCION_LIMITE
        LogHelper.Out(getDataByAdministratorId.name, localValue, 'GET_MODALIDAD_DISTRIBUCION_LIMITE', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_MODALIDAD_DISTRIBUCION_LIMITE', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

        //GET_PRODUCTO_CAMPO
        LogHelper.Out(getDataByAdministratorId.name, localValue, 'GET_PRODUCTO_CAMPO', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_PRODUCTO_CAMPO', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

        //GET_ATLAS_HABILITACION_TARJETA
        LogHelper.Out(getDataByAdministratorId.name, localValue, 'GET_ATLAS_HABILITACION_TARJETA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_ATLAS_HABILITACION_TARJETA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

        //GET_ATLAS_SEGMENTO_CARTERA
        LogHelper.Out(getDataByAdministratorId.name, localValue, 'GET_ATLAS_SEGMENTO_CARTERA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_ATLAS_SEGMENTO_CARTERA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

        //GET_ATLAS_MARCAR_COMPARTIDA
        LogHelper.Out(getDataByAdministratorId.name, localValue, 'GET_ATLAS_MARCA_COMPARTIDA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_ATLAS_MARCA_COMPARTIDA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

        //GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA
        LogHelper.Out(getDataByAdministratorId.name, localValue, 'GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA', "Get", 'Tarjetas', 'PARAMETRIA', 1, "Product");

        //GET_ATLAS_COMERCIALIZADORA_CANAL_VENTA
        LogHelper.Out(getDataByAdministratorId.name, localValue, 'GET_ATLAS_COMERCIALIZADORA_CANAL_VENTA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_ATLAS_COMERCIALIZADORA_CANAL_VENTA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

        //GET_SOLICITUD_ESTADO
        LogHelper.Out(getDataByAdministratorId.name, null, 'GET_SOLICITUD_ESTADO', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(null, 'GET_SOLICITUD_ESTADO', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');

        //GET_COMERCIALIZADORA_CANAL_VENTA_BY_ADMIN
        LogHelper.Out(getDataByAdministratorId.name, localValue, 'GET_COMERCIALIZADORA_CANAL_VENTA_BY_ADMIN', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_COMERCIALIZADORA_CANAL_VENTA_BY_ADMIN', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

        //GET_ATLAS_TIPO_COMUNICACION
        LogHelper.Out(getDataByAdministratorId.name, localValue, 'GET_ATLAS_TIPO_COMUNICACION', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_ATLAS_TIPO_COMUNICACION', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

        //GET_PRODUCTO_CABAL 
        LogHelper.Out(getDataByAdministratorId.name, paramsGetDatosProductoById, 'GET_PRODUCTO_CABAL', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramsGetDatosProductoById, 'GET_PRODUCTO_CABAL', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

        //GET_PRODUCTO_DEFAULT_CABAL
        LogHelper.Out(getDataByAdministratorId.name, paramsGetDatosProductoById, 'GET_PRODUCTO_DEFAULT_CABAL', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramsGetDatosProductoById, 'GET_PRODUCTO_DEFAULT_CABAL', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

        //GET_DATOS_PRODUCTO_BY_ID
        LogHelper.Out(getDataByAdministratorId.name, paramsGetDatosProductoById, 'GET_DATOS_PRODUCTO_BY_ID', "Get", 'Tarjetas', 'ADMINPRODUCTOS', 1, "Product");
        Engine1Proxy.AddDataSourcesRequests(paramsGetDatosProductoById, 'GET_DATOS_PRODUCTO_BY_ID', "Get", 'Tarjetas', 'ADMINPRODUCTOS', 1, "Product");

        Engine1Proxy.Execute((data) => _loadGetDataByAdministratorId(data, administradoraAbreviatura, administratorId, dispatch), null, null, "ADMINPRODUCTOS");

        LogHelper.Out(getDataByAdministratorId.name, administratorId, administradoraAbreviatura);
    }
}

export function resetLimites() {
    LogHelper.In(resetLimites.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: RESET_LIMITES });
    }

}

export function getGruposafinidad(tipoCuenta){
    LogHelper.In(getGruposafinidad.name, tipoCuenta);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        
        let state= getState();
        state = state.producto.data;

        let tipoCuentaSel = {
            TIPO_CUENTA_ID: tipoCuenta
        }
        
        Engine1Proxy.AddDataSourcesRequests( tipoCuentaSel, 'GET_GRUPOS_AFINIDAD_BY_TIPO_CUENTA', "Get", 'Tarjetas', 'ADMINPRODUCTOS', 1, "Product");
        Engine1Proxy.Execute((data) => _getGruposAfinidadCallback(data,state), null, null, "ADMINPRODUCTOS");
    }
}


// ---------------------------------------------------- FUNCIONES AUXILIARES ---------------------------------------------------- //
/**
 * 
 * @param {any} data
 */

 function _getGruposAfinidadCallback(data,state){
    
    let arr2 = [];
    let gruposAfinidad = JSON.parse(data.GET_GRUPOS_AFINIDAD_BY_TIPO_CUENTA).Recordset0.Rows;

    state.GET_GRUPO_AFINIDAD_ADMINISTRADORA.map(ga=>{if(gruposAfinidad.some(ga2=>ga2.Id == ga.Id)) arr2.push(ga)});

    _dispatch({ type: GET_GRUPOS_AFINIDAD_BY_TIPO_CUENTA, payload: arr2  });
 }


function _loadScreenData(data) {
    LogHelper.In(_loadScreenData.name, data);

    let userFeatures = JSON.parse(JSON.stringify(data)); //Todos los permisos por feature del usuario en el programa.
    let userFunctions = JSON.parse(JSON.stringify(data.ADMINPRODUCTOS)); //Permisos del usuario para la feature a utilizar.

    userFunctions.Alta = userFunctions.some(f => {
        return f.Codigo_Funcion == FUNCTION_CODE_CREATE_PRODUCTO
    });

    userFunctions.Consulta = userFunctions.some(f => {
        return f.Codigo_Funcion == FUNCTION_CODE_QUERY
    });

    _userFeatures = userFeatures;
    _userFunctions = userFunctions;

    let panams = {
        ADMINISTRADORA_ID: 1
    }

    if (_productoId != "0") {
        /*Si tiene permisos sobre la consulta de la pantalla, hago el resto de las llamadas*/
        if (userFunctions.Consulta == true) {
            obtenerAbreviaturaProductoId(_productoId);
        }
    }
    else {
        /*Si tiene permisos sobre la consulta de la pantalla, hago el resto de las llamadas*/
        if (userFunctions.Consulta == true) {
            obtenerDataSources(panams);
        }
    }
}

/**
 * 
 * @param {any} productoId
 */
function obtenerAbreviaturaProductoId(productoId) {
    LogHelper.In(obtenerAbreviaturaProductoId.name, productoId);
    let prodId = {
        PRODUCTO_ID: productoId
    }

    Engine1Proxy.AddDataSourcesRequests(prodId, 'GET_ADMINISTRADORAID_BY_PRODUCTOID', "Get", 'Tarjetas', 'PARAMETRIA', 1, "Product");
    Engine1Proxy.Execute(_obtenerAbreviaturaProductoIdInitialStateData, null, null, "PARAMETRIA");
}

/**
 * 
 * @param {any} data
 */
function _obtenerAbreviaturaProductoIdInitialStateData(data) {
    LogHelper.In(_obtenerAbreviaturaProductoIdInitialStateData.name, data);
    let administradoraId = JSON.parse(data.GET_ADMINISTRADORAID_BY_PRODUCTOID).Recordset0.Rows[0].AdministradoraId;

    _administradoraId = administradoraId;

    let nuevoParametro = {
        ADMINISTRADORA_ID: administradoraId
    }

    obtenerDataSources(nuevoParametro);
}

function obtenerDataSources(parametro) {
    LogHelper.Out(obtenerDataSources.name, null, 'GET_ADMINISTRADORA', "Get", 'Tarjetas', 'PARAMETRIA', 1, "Product");
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_ADMINISTRADORA', "Get", 'Tarjetas', 'PARAMETRIA', 1, "Product");
    Engine1Proxy.AddDataSourcesRequests(parametro, 'GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA', "Get", 'Tarjetas', 'PARAMETRIA', 1, "Product");
    Engine1Proxy.AddDataSourcesRequests(parametro, 'GET_SUCURSAL', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(parametro, 'GET_GRUPO_AFINIDAD_ADMINISTRADORA_ACTIVOS', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(parametro, 'GET_PARAMETRO_GENERAL', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(parametro, 'GET_CODIGO_DISTRIBUCION', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(parametro, 'GET_COMERCIALIZADORA_CANAL_VENTA_BY_ADMIN', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(parametro, 'GET_ATLAS_COMERCIALIZADORA_CANAL_VENTA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(parametro, 'GET_ATLAS_TIPO_COMUNICACION', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

    Engine1Proxy.Execute(_loadUserListInitialStateData, null, null, "PARAMETRIA");
}

/**
 * 
 * @param {any} data
 */
function _loadUserListInitialStateData(data) {
    LogHelper.In(_loadUserListInitialStateData.name, data);

    let getAdministradoraParam = JSON.parse(data.GET_ADMINISTRADORA).Recordset0.Rows;
    let GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA = JSON.parse(data.GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA).Recordset0.Rows;
    let GET_SUCURSAL = JSON.parse(data.GET_SUCURSAL).Recordset0.Rows;
    let GET_GRUPO_AFINIDAD_ADMINISTRADORA = JSON.parse(data.GET_GRUPO_AFINIDAD_ADMINISTRADORA_ACTIVOS).Recordset0.Rows;
    let GET_PARAMETRO_GENERAL = JSON.parse(data.GET_PARAMETRO_GENERAL).Recordset0.Rows;
    let GET_CODIGO_DISTRIBUCION = JSON.parse(data.GET_CODIGO_DISTRIBUCION).Recordset0.Rows;

    let GET_ATLAS_TIPO_COMUNICACION = JSON.parse(data.GET_ATLAS_TIPO_COMUNICACION).Recordset0.Rows;

    if (GET_PARAMETRO_GENERAL.length && GET_PARAMETRO_GENERAL.length > 0) {
        GET_PARAMETRO_GENERAL = GET_PARAMETRO_GENERAL[0];
    }

    let selectedAdministrator = (getAdministradoraParam.find(x => x.Id == _administradoraId) && getAdministradoraParam.find(x => x.Id == _administradoraId).Abreviatura);

    let result = {
        GET_ADMINISTRADORA: getAdministradoraParam,
        GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA: GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA,
        GET_SUCURSAL: GET_SUCURSAL,
        GET_GRUPO_AFINIDAD_ADMINISTRADORA: GET_GRUPO_AFINIDAD_ADMINISTRADORA,
        GET_PARAMETRO_GENERAL: GET_PARAMETRO_GENERAL,
        GET_CODIGO_DISTRIBUCION: GET_CODIGO_DISTRIBUCION,
        GET_ATLAS_TIPO_COMUNICACION: GET_ATLAS_TIPO_COMUNICACION,
        edicion: _productoId && _productoId != "0",
        selectedAdministrator: selectedAdministrator,
        userFeatures: _userFeatures,
        userFunctions: _userFunctions
    }

    _dispatch({ type: GET_SCREEN_DATA_RESULT_PRODUCTO, data: result });

}

/**
 * Funcion encargada del ruteo.
 * @param {any} params
 * @param {any} option
 * @param {any} dispatch
 */
function _routing(params, option, dispatch) {
    LogHelper.In(_routing.name, params, option, dispatch);

    if (params) {
        params = JSON.stringify(params);
    }

    const redirectLocation = ProcessManager.GetNextStep("Producto", option, params);

    dispatch({ type: ROUTE_TO_PRODUCTOS_PRODUCTO, data: redirectLocation })
}

/**
 * 
 * @param {any} data
 * @param {any} selectedAdministrator
 */
function _loadGetDataByAdministratorId(data, selectedAdministrator, administratorId) {
    LogHelper.In(_loadGetDataByAdministratorId.name, data, selectedAdministrator);
    
    /*
     GET_DATOS_PRODUCTO_BY_ID
        Recordset1 => Producto, Producto_Visa y Defaults
        Recordset2 => Sucursales
        Recordset3 => Modelo de Liquidacion 
        Recordset4 => Grupo de Afinidad
        Recordset5 => Limite de compra
        Recordset6 => Modalidad de distribucion de limites
        Recordset7 => Cartera
        Recordset8 => Forma de Pago
        Recordset9 => Forma de Debito
        Recordset10 => Linea Prestamo
        Recordset11 => Categoria Atm
        Recordset12 => Codigo de distribucion
        Recordset13 => Habilitación Tarjeta
        Recordset14 => Segmento Cartera
        Recordset15 => Comercializadora Canal
        Recordset16 => Marca Compartida
     */

    let producto;
    let productoDefaultCabal;
    const comercializadoras = [];
    let canalVentas = [];

    //PARAMETRO GENERAL
    const parametroGeneral = JSON.parse(data.GET_PARAMETRO_GENERAL).Recordset0.Rows[0] || {};
    /*Datos del producto*/
    let marca = _administradoraId;
    ;
    switch (marca) {
        case 1:
            producto = JSON.parse(data.GET_DATOS_PRODUCTO_BY_ID).Recordset0.Rows[JSON.parse(data.GET_DATOS_PRODUCTO_BY_ID).Recordset0.Rows.length - 1];
            break;
        case 2:
            //PARAMETRO GENERAL
            let parametroGetAltaProductoCabal = JSON.parse(data.GET_ALTA_PRODUCTO_CABAL);
            const GET_ALTA_PRODUCTO_CABAL = {
                'ATLAS_ADMINISTRADORA': parametroGetAltaProductoCabal.Recordset0.Rows,
                'ATLAS_GRUPO_AFINIDAD': parametroGetAltaProductoCabal.Recordset1.Rows,
                'ATLAS_SEGMENTO_CARTERA': parametroGetAltaProductoCabal.Recordset2.Rows,
                'ATLAS_MARCA_COMPARTIDA': parametroGetAltaProductoCabal.Recordset3.Rows,
                'ATLAS_TIPO_COMUNICACION': parametroGetAltaProductoCabal.Recordset4.Rows,
                'GET_DATOS_PRODUCTO_BY_ID': JSON.parse(data.GET_DATOS_PRODUCTO_BY_ID).Recordset0.Rows[JSON.parse(data.GET_DATOS_PRODUCTO_BY_ID).Recordset0.Rows.length - 1],
            }

            //GET_PRODUCTO_CABAL
            producto = JSON.parse(data.GET_PRODUCTO_CABAL).Recordset0.Rows[JSON.parse(data.GET_PRODUCTO_CABAL).Recordset0.Rows.length - 1];

            if (GET_ALTA_PRODUCTO_CABAL && GET_ALTA_PRODUCTO_CABAL.GET_DATOS_PRODUCTO_BY_ID)
                producto.Nombre = GET_ALTA_PRODUCTO_CABAL.GET_DATOS_PRODUCTO_BY_ID.Nombre;

            //GET_PRODUCTO_DEFAULT_CABAL
            productoDefaultCabal = JSON.parse(data.GET_PRODUCTO_DEFAULT_CABAL).Recordset0.Rows;
            break;
        default:
    }
   
    const sucursalesProducto = JSON.parse(data.GET_DATOS_PRODUCTO_BY_ID).Recordset1.Rows;
    const modelosLiquidacionProducto = JSON.parse(data.GET_DATOS_PRODUCTO_BY_ID).Recordset2.Rows;
    const grupoAfinidadProducto = JSON.parse(data.GET_DATOS_PRODUCTO_BY_ID).Recordset3.Rows;
    const limitesCompraProducto = JSON.parse(data.GET_DATOS_PRODUCTO_BY_ID).Recordset4.Rows;
    const modalidadesDistribucionProductos = JSON.parse(data.GET_DATOS_PRODUCTO_BY_ID).Recordset5.Rows;
    const carterasProducto = JSON.parse(data.GET_DATOS_PRODUCTO_BY_ID).Recordset6.Rows;
    const formasPagoProducto = JSON.parse(data.GET_DATOS_PRODUCTO_BY_ID).Recordset7.Rows;
    const formasDebitoProducto = JSON.parse(data.GET_DATOS_PRODUCTO_BY_ID).Recordset8.Rows;
    const lineasPrestamoProducto = JSON.parse(data.GET_DATOS_PRODUCTO_BY_ID).Recordset9.Rows;
    const categoriasAtmProducto = JSON.parse(data.GET_DATOS_PRODUCTO_BY_ID).Recordset10.Rows;
    const codigosDistribucionProducto = JSON.parse(data.GET_DATOS_PRODUCTO_BY_ID).Recordset11.Rows;
    const habilitacionTarjetaProducto = JSON.parse(data.GET_DATOS_PRODUCTO_BY_ID).Recordset12.Rows;
    const segmentoCarteraProducto = JSON.parse(data.GET_DATOS_PRODUCTO_BY_ID).Recordset13.Rows;
    const comercializadoraCanalProducto = JSON.parse(data.GET_DATOS_PRODUCTO_BY_ID).Recordset14.Rows;
    const marcaCompartidaProducto = JSON.parse(data.GET_DATOS_PRODUCTO_BY_ID).Recordset15.Rows;

    
    //ES EDICION
    let edicion = (producto != undefined);

    /*FUNCIONAMIENTO LIMITES*/
    const funcionamientoLimites = [
        { Id: 1, Codigo: "OT", Descripcion: "Otorgados", Checked: false, Visible: true },
        { Id: 2, Codigo: "LU", Descripcion: "Unificados (LU)", Checked: false, Visible: true }
    ];

    //DENOMINACIÓN DE 4 LÍNEA
    let denominacionCuartaLineas;
    switch (marca) {
        case 1:
            denominacionCuartaLineas = [
                { Id: 1, Descripcion: "Cartera", Checked: false, Codigo: "Cartera" },
                { Id: 2, Descripcion: "Grupo Afinidad", Checked: false, Codigo: "GAF" },
                { Id: 3, Descripcion: "Sucursal", Checked: false, Codigo: "Sucursal" },
                { Id: 4, Descripcion: "Modelo Liquidaci\u00F3n", Checked: false, Codigo: "ModLiq" },
                { Id: 5, Descripcion: "Texto:", Checked: false, Codigo: "Texto" }
            ];
            break;
        case 2:
            denominacionCuartaLineas = [
                { Id: 1, Descripcion: "Ciclo de Facturacion", Checked: false, Codigo: "CicloFacturacion" },
                { Id: 2, Descripcion: "Grupo Afinidad", Checked: false, Codigo: "GAF" },
                { Id: 3, Descripcion: "Sucursal", Checked: false, Codigo: "Sucursal" },
                { Id: 4, Descripcion: "Segmento de Cartera", Checked: false, Codigo: "Segmento" },
                { Id: 6, Descripcion: "Marca Compartida", Checked: false, Codigo: "MarcaComp" },
                { Id: 5, Descripcion: "Texto:", Checked: false, Codigo: "Texto" }
            ];
            break;
        default:
    }


    const costoEmisiones = [
        { Id: 1, Descripcion: "Sin Cargo (SC)", Checked: false, CostoEmision: "SC" },
        { Id: 2, Descripcion: "Bonificado Parcialmente", Checked: false, CostoEmision: "BP" },
        { Id: 3, Descripcion: "Bonificado al 100%", Checked: false, CostoEmision: "BT" },
        { Id: 4, Descripcion: "Cargo en Cuotas", Checked: false, CostoEmision: undefined },
        { Id: 5, Descripcion: "Sin Bonificar", Checked: false, CostoEmision: "SB" }
    ];

    const usoCajerosAutomaticos = [
        { Id: 1, Descripcion: "Sin Cargo para el Usuario", Checked: false, Codigo: "SC" },
        { Id: 2, Descripcion: "Con Cargo para el Usuario", Checked: false, Codigo: "CC" }
    ];

    const senalPreEmision = [
        { Id: 1, Descripcion: "0: Normal", Checked: false, Codigo: 1 },
        { Id: 2, Descripcion: "1: Pre-Emitida (tarjetas inhabilitadas causa '8')", Checked: false, Codigo: 2 }
    ];

    const preEmision = [
        { Id: 1, Descripcion: "No permite activación telefónica", Checked: false, Codigo: 0 },
        { Id: 2, Descripcion: "Permite activación telefónica", Checked: false, Codigo: 1 }
    ];

    const altaPosDatada = [
        { Id: 1, Descripcion: "'S' Alta Pos Datada", Checked: false, Codigo: 'S' },
        { Id: 2, Descripcion: "'N' Sin Alta Pos Datada", Checked: false, Codigo: 'N' }
    ];

    const retencionTarjetaCabal = [
        { Id: 1, Descripcion: "Distribución Normal", Checked: false, Codigo: 'N' },
        { Id: 2, Descripcion: "A Cargo Entidad", Checked: false, Codigo: 'E' }
    ];

    /*--------------------------------------------SUCURSALES--------------------------------------------*/
    const atlasSucursal = JSON.parse(data.GET_SUCURSAL).Recordset0.Rows;
    const sucursales = _createArrayProducto(atlasSucursal, sucursalesProducto, "ProductoSucursalId", "SucursalId", edicion, false);
    /*--------------------------------------------SUCURSALES--------------------------------------------*/

    /*--------------------------------------------MODELOS LIQUIDACION--------------------------------------------*/
    const altasLiquidacion = JSON.parse(data.GET_MODELO_LIQUIDACION_ADMINISTRADORA).Recordset0.Rows;
    const modelosLiquidacion = _createArrayProducto(altasLiquidacion, modelosLiquidacionProducto, "ProductoModeloLiquidacionId", "ModeloLiquidacionId", edicion, false);
    /*--------------------------------------------MODELOS LIQUIDACION--------------------------------------------*/

    /*--------------------------------------------GRUPOS DE AFINIDAD--------------------------------------------*/
    const atlasGrupoAfinidad = (producto && !productoDefaultCabal) ?  JSON.parse(data.GET_ATLAS_GRUPOS_AFINIDAD_BY_ID_PRODUCTO).Recordset0.Rows : JSON.parse(data.GET_GRUPO_AFINIDAD_ADMINISTRADORA_ACTIVOS).Recordset0.Rows;
    let gruposAfinidad = _createArrayProducto(atlasGrupoAfinidad, grupoAfinidadProducto, "ProductoGrupoAfinidadId", "GrupoAfinidadId", edicion, false);
    /*--------------------------------------------GRUPOS DE AFINIDAD--------------------------------------------*/
   
    /*--------------------------------------------LIMITES DE COMPRA--------------------------------------------*/
    const atlasLimiteCompra = JSON.parse(data.GET_LIMITE_COMPRA).Recordset0.Rows;
    const limiteCompras = _createArrayProducto(atlasLimiteCompra, limitesCompraProducto, "ProductoLimiteCompraId", "LimiteCompraId", edicion, false);
    /*--------------------------------------------LIMITES DE COMPRA--------------------------------------------*/

    /*--------------------------------------------MODELOS DE ASIGNACION--------------------------------------------*/
    const atlasModelosAsignacion = JSON.parse(data.GET_MODALIDAD_DISTRIBUCION_LIMITE).Recordset0.Rows;
    const modelosAsignacion = _createArrayProducto(atlasModelosAsignacion, modalidadesDistribucionProductos, "ProductoModalidadDistribucionLimiteId", "ModalidadDistribucionLimiteId", edicion, false);
    /*--------------------------------------------MODELOS DE ASIGNACION--------------------------------------------*/

    /*--------------------------------------------CARTERAS--------------------------------------------*/
    const atlasCarteras = JSON.parse(data.GET_CARTERAS).Recordset0.Rows;
    const carteras = _createArrayProducto(atlasCarteras, carterasProducto, "ProductoCarteraId", "CarteraId", edicion, false);
    /*--------------------------------------------CARTERAS--------------------------------------------*/

    /*--------------------------------------------FORMAS DE PAGO--------------------------------------------*/
    const atlasFormasPago = JSON.parse(data.GET_FORMA_PAGO).Recordset0.Rows;
    const formasPago = _createArrayProducto(atlasFormasPago, formasPagoProducto, "ProductoFormaPagoId", "FormaPagoId", edicion, false, _productoId && _productoId == 0 && selectedAdministrator == "C" && formasPagoProducto.length == 0);
    
    /*--------------------------------------------FORMAS DE PAGO--------------------------------------------*/

    /*--------------------------------------------FORMAS DE DEBITO--------------------------------------------*/
    const atlasFormasDebito = JSON.parse(data.GET_FORMA_DEBITO).Recordset0.Rows;
    const formasDebito = _createArrayProducto(atlasFormasDebito, formasDebitoProducto, "ProductoFormaDebitoId", "FormaDebitoId", edicion, false,  _productoId && _productoId == 0 && selectedAdministrator == "C" && formasDebitoProducto.length == 0);
    /*--------------------------------------------FORMAS DE DEBITO--------------------------------------------*/
    
    /*--------------------------------------------LINEA PRESTAMO--------------------------------------------*/
    const atlasLineaPrestamo = JSON.parse(data.GET_LINEA_PRESTAMO).Recordset0.Rows;
    const lineasPrestamo = _createArrayProducto(atlasLineaPrestamo, lineasPrestamoProducto, "ProductoLineaPrestamoId", "LineaPrestamoId", edicion, false);
    /*--------------------------------------------LINEA PRESTAMO--------------------------------------------*/

    /*--------------------------------------------CATEGORIA ATM--------------------------------------------*/
    const atlasCategoriaCajero = JSON.parse(data.GET_CATEGORIA_CAJERO).Recordset0.Rows;
    const categoriasAtm = _createArrayProducto(atlasCategoriaCajero, categoriasAtmProducto, "ProductoCategoriaAtmId", "CategoriaAtmId", edicion, false);
    /*--------------------------------------------CATEGORIA ATM--------------------------------------------*/

    /*--------------------------------------------CODIGOS DE DISTRIBUCION--------------------------------------------*/
    const atlasCodigoDistribucion = JSON.parse(data.GET_CODIGO_DISTRIBUCION).Recordset0.Rows;
    const codigosDistribucion = _createArrayProducto(atlasCodigoDistribucion, codigosDistribucionProducto, "ProductoCodigoDistribucionId", "CodigoDistribucionId", edicion, false);
    /*--------------------------------------------CODIGOS DE DISTRIBUCION--------------------------------------------*/
    
    /*--------------------------------------------HABILITACION TARJETAS--------------------------------------------*/
    const atlasHabilitacionTarjeta = JSON.parse(data.GET_ATLAS_HABILITACION_TARJETA).Recordset0.Rows;
    const habilitacionTarjetas = _createArrayProducto(atlasHabilitacionTarjeta, habilitacionTarjetaProducto, "ProductoHabilitacionTarjetaId", "HabilitacionTarjetaId", edicion, false);
    /*--------------------------------------------HABILITACION TARJETAS--------------------------------------------*/

    /*--------------------------------------------SEGMENTO CARTERA--------------------------------------------*/
    const atlasSegmentoCartera = JSON.parse(data.GET_ATLAS_SEGMENTO_CARTERA).Recordset0.Rows;
    let segmentoCarteras = _createArrayProducto(atlasSegmentoCartera, segmentoCarteraProducto, "ProductoSegmentoCarteraId", "SegmentoCarteraId", edicion, false);
    /*--------------------------------------------SEGMENTO CARTERA--------------------------------------------*/

    /*--------------------------------------------MARCA COMPARTIDA--------------------------------------------*/
    const atlasMarcaCompartida = JSON.parse(data.GET_ATLAS_MARCA_COMPARTIDA).Recordset0.Rows;
    let marcaCompartidas = _createArrayProducto(atlasMarcaCompartida, marcaCompartidaProducto, "ProductoMarcaCompartidaId", "MarcaCompartidaId", edicion, false);
    /*--------------------------------------------MARCA COMPARTIDA--------------------------------------------*/
    
    /*TIPOS EMPRESA*/

    const tiposEmpresa = JSON.parse(data.GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA).Recordset0.Rows.map((item) => {
        item.Checked = false;

        if (producto && (item.Id == producto.TipoProductoId)) {
            item.Checked = true;
            producto.TipoProductoEmpInd = item.EmpresaIndividuos;
        }

        return item;
    });

    /*TIPO COMUNICACION - CORRESPONDENCIA*/
    const tipoComunicaciones = JSON.parse(data.GET_ATLAS_TIPO_COMUNICACION).Recordset0.Rows.map(item => {
        item.Checked = false;

        if (!producto) {
            if (parametroGeneral && parametroGeneral.TIPOCOMUNICACIONID) {
                item.Checked = (item.Id == parametroGeneral.TIPOCOMUNICACIONID)
            }
        } else {
            item.Checked = (item.Id == producto.TipoCorrespondenciaId);
        }
        return item;
    });


    /*GET_SOLICITUD_ESTADO*/
    const solicitudEstados = JSON.parse(data.GET_SOLICITUD_ESTADO).Recordset0.Rows.map(item => {
        if (item.Id == 3) {
            item.Descripcion = "Confirmada";
        }else if(item.Id ==2){
            item.Descripcion = "Completada";
        }

        item.Checked = false;

        if (!producto) {
            if (parametroGeneral && parametroGeneral.ESTADOSOLICITUDINGRESOID) {
                item.Checked = (item.Id == parametroGeneral.ESTADOSOLICITUDINGRESOID)
            }
        } else {
            item.Checked = (item.Id == producto.SolicitudEstadoId);
        }

        return item;
    });
    /*COMERCIALIZADORA_CANAL_VENTA*/

    JSON.parse(data.GET_COMERCIALIZADORA_CANAL_VENTA_BY_ADMIN).Recordset0.Rows.forEach((element, index, self) => {
        
        const existeComercializadora = comercializadoras.some(s => s.Id == element.ComercializadoraId);

        if (!existeComercializadora) {
            canalVentas = self.filter(s => s.RelacionComercializadoraId == element.ComercializadoraId);
            const idsComProductos = comercializadoraCanalProducto.map(ccp => ccp.ComercializadoraCanalId);
            const existChildrenChecked = canalVentas.some(cv => idsComProductos.indexOf(cv.RelacionComercializadoraCanalVentaId) >= 0);

            if (element.ComercializadoraActivo || canalVentas.find(cv => comercializadoraCanalProducto.find(ccp => ccp.ComercializadoraCanalId == cv.RelacionComercializadoraCanalVentaId) != undefined)) {

                comercializadoras.push({
                    Id: element.ComercializadoraId,
                    Descripcion: element.ComercializadoraDescripcion,
                    Codigo: element.ComercializadoraCodigo,
                    Checked: existChildrenChecked,
                    Activo: element.ComercializadoraActivo,
                    CanalVentas: canalVentas.filter(x => comercializadoraCanalProducto.find(ccp => ccp.ComercializadoraCanalId == x.RelacionComercializadoraCanalVentaId) != undefined || x.CanalVentaActivo).filter(cN=>cN.RelacionActivo).map(s => {
                        const cvEncontrado = comercializadoraCanalProducto.find(ccp => ccp.ComercializadoraCanalId == s.RelacionComercializadoraCanalVentaId);
                        return {
                            Id: s.CanalVentaId,
                            Descripcion: s.CanalVentaDescripcion,
                            Codigo: s.CanalVentaCodigo,
                            Checked: (cvEncontrado != undefined),
                            RelacionId: s.RelacionComercializadoraCanalVentaId,
                            ComercializadoraCanalId: ((cvEncontrado) ? cvEncontrado.Id : null),
                            Activo: s.CanalVentaActivo,
                            RelacionActiva: s.RelacionActivo
                        }

                    })
                });
            }
        }
    });

    


    /*DENOMINACION CUARTA LINEA*/
    denominacionCuartaLineas.forEach(item => {
        if (producto) {
            item.Checked = (item.Codigo == producto.TipoGrabadoCuartaLinea);
        }
    });

    if (producto) {
        producto.HabilitaCuartaLinea = denominacionCuartaLineas.some(item => item.Checked);
    }

    /*FUNCIONAMIENTO LIMITES*/
    funcionamientoLimites.forEach(item => {
        if (producto) {
            item.Checked = (item.Codigo == producto.TipoLimiteIndividuos);
        }
    });
    /*CAJEROS AUTOMATICOS*/
    usoCajerosAutomaticos.forEach(item => {
        if (producto) {
            item.Checked = (item.Codigo == producto.UsoATM);
        }
    });

    /*SEÑALPREEMISION*/
    senalPreEmision.forEach(item => {
        if (producto) {
            if (producto.PreEmision == 2) {
                item.Checked = true 
            } else if(producto.PreEmision == 0) {
                item.Checked = (item.Codigo == 1);
            } else if(producto.PreEmision == 1) {
                item.Checked = (item.Codigo == 2);
            }else if(producto.preEmision == null){
                item.Checked = false
            }
        }
    });

    if (producto) {
        producto.HabilitarSenalPreEmision = producto.PreEmision != null;
    }
    

    /*PREEMISION*/
    preEmision.forEach(item => {
        if (producto) {
            if(item.Codigo==0){
                item.Checked = producto.ActivacionTelefonica == false
            }
            if(item.Codigo==1)
                item.Checked = producto.ActivacionTelefonica == true
        }
    });

    if (producto && productoDefaultCabal) {
        producto.PreEmitida = senalPreEmision.some(item => item.Id==2 && item.Checked);
        producto.PreEmisionDefaultInterfaz = productoDefaultCabal[0].PreEmisionDefaultInterfaz
        if(producto.PreEmisionDefaultInterfaz){
            producto.PreEmisionDefaultId  = productoDefaultCabal[0].PreEmisionDefault == true ? "2" : "1"
        }else{
            producto.PreEmisionDefaultId = null
        }
    }
   

    /*ALTA POSDATADA*/

    altaPosDatada.forEach(item => {
        if (producto && productoDefaultCabal ) {
            if (producto.AltaPosDatada == 'S') {
                if(item.Id==1) item.Checked = true;
            }else if(producto.AltaPosDatada == 'N') {
                if(item.Id==2) item.Checked = true;
            }else if(producto.AltaPosDatada == 'A'){
                item.Checked = true;
            }
        }
    });
    
    if (producto && productoDefaultCabal) {
        producto.HabilitarAltaPosDatada = altaPosDatada.some(item => item.Checked);
        producto.AltaPosDatadaDefaultInterfaz  = productoDefaultCabal[0].AltaPosdatadaDefaultInterfaz
        producto.AltaPosDatadaDefaultId = productoDefaultCabal[0].AltaPosdatadaDefaultInterfaz ? (productoDefaultCabal[0].AltaPosdatadaDefault == "N" ? 1 : 2) : null 
    }
    
    /*RETENCION TARJETA CABAL*/
    retencionTarjetaCabal.forEach(item => {
        if (producto && productoDefaultCabal) {
            if (producto.RetencionTarjeta == 'A') {
                item.Checked = true;
            } else {
                item.Checked = (item.Codigo == producto.RetencionTarjeta);
            }
        }
    });
    
    if (producto && productoDefaultCabal) {
        producto.HabilitarRetencionTarjeta = retencionTarjetaCabal.some(item => item.Checked);
        producto.RetencionTarjetaDefaultInterfaz  = productoDefaultCabal[0].RetencionTarjetaDefaultInterfaz
        producto.RetencionTarjetaDefaultId = productoDefaultCabal[0].RetencionTarjetaDefaultInterfaz ? (productoDefaultCabal[0].RetencionTarjetaDefault == 'S' ? 1 : 2) : null
    }

    // SEGMENTO CARTERA

    if(segmentoCarteras){
        if(producto){
            segmentoCarteras = _checkActivo(atlasSegmentoCartera,segmentoCarteras)
        }else{
            segmentoCarteras = segmentoCarteras.filter(e=>e.Activo == true)
        }
    }

    // MARCA COMPARTIDA

    if(marcaCompartidas){
        if(producto){
            marcaCompartidas = _checkActivo(atlasMarcaCompartida,marcaCompartidas)
        }else{
            marcaCompartidas = marcaCompartidas.filter(e=>e.Activo == true)
        }
    }

    
    
    //PRODUCTO CAMPO
    let getProductFieldParam = JSON.parse(data.GET_PRODUCTO_CAMPO).Recordset0.Rows;
    getProductFieldParam.unshift({ Id: 0, Nombre: "Seleccione el campo...", ProductoReglaTipoId: 1, Tabla: "DEFAULT" });

    let getProductRuleParam = []
    getProductRuleParam.forEach(function (item) {
        item.SelectedPreCampoId = undefined;
        item.SelectedPostCampoId = undefined;
        item.PreOptions = [];
        item.PostOptions = [];
    });

    let tipoEmpresa = tiposEmpresa.filter(x => x.Checked);

    if (tiposEmpresa.length == 0) {
        gruposAfinidad = gruposAfinidad.map(x => ({ ...x, filtrado: x.AdministradoraId == administratorId }));
    } else if (gruposAfinidad.length > 0 && tipoEmpresa.length > 0) {
        gruposAfinidad = gruposAfinidad.map(x => ({ ...x, filtrado: x.AdministradoraId == administratorId && x.CuentaTipoId == tipoEmpresa[0].Id }));
    } else if (gruposAfinidad.length > 0) {
        gruposAfinidad = gruposAfinidad.map(x => ({ ...x, filtrado: x.AdministradoraId == administratorId && x.CuentaTipoId == tiposEmpresa[0].Id }));
    }
    
    //FORMA DE PAGO

    /*if(producto && productoDefaultCabal){
        producto.FormaPagoDefaultId= productoDefaultCabal[0].FormaPagoDefaultId;
        producto.FormaPagoDefaultInterfaz= productoDefaultCabal[0].FormaPagoDefaultInterfaz;
        producto.TipoDebitoDefaultId= productoDefaultCabal[0].TipoDebitoDefaultId;
        producto.TipoDebitoDefaultInterfaz = productoDefaultCabal[0].TipoDebitoDefaultInterfaz; 
    }*/
    //SI NO SE TRATA DE UNA MODIFICACIÓN TODAS LAS FORMAS DE PAGO Y DE DÉBITO DEBEN ESTAR TILDADAS POR DEFECTO//
    if(!producto){
        formasPago.map(e=>e.Checked = e.Activo ? true : false)
        formasDebito.map(e=>e.Checked = e.Activo ? true : false)
    }else{ // SI HAY PRODUCTO APLICO ESTA FUNCION A TODOS LOS ARREGLOS PARA QUE INHABILITE LAS ELECCIONES GUARDADAS QUE YA NO ESTÁN DISPONIBLES
        _checkActivo(atlasFormasPago,formasPago)
        _checkActivo(atlasFormasDebito,formasDebito)
        _checkActivo(atlasCarteras,carteras)
        _checkActivo(atlasCategoriaCajero,categoriasAtm)
        _checkActivo(atlasCodigoDistribucion,codigosDistribucion)
        _checkActivo(atlasGrupoAfinidad,gruposAfinidad)
        _checkActivo(atlasLineaPrestamo,lineasPrestamo)
    }
    

    let result = {
        GET_SUCURSAL: sucursales,
        GET_MODELO_LIQUIDACION_ADMINISTRADORA: modelosLiquidacion,
        GET_GRUPO_AFINIDAD_ADMINISTRADORA: gruposAfinidad,
        GET_LIMITE_COMPRA: limiteCompras,
        GET_CARTERAS: carteras,
        GET_LINEA_PRESTAMO: lineasPrestamo,
        GET_CATEGORIA_CAJERO: categoriasAtm,
        GET_CODIGO_DISTRIBUCION: codigosDistribucion,
        GET_FORMA_PAGO: formasPago,
        GET_FORMA_DEBITO: formasDebito,
        GET_MODALIDAD_DISTRIBUCION_LIMITE: modelosAsignacion.map(c => ({ ...c, filtered: ((producto != undefined && c.EmpresaIndividuos == producto.TipoProductoEmpInd) || (!producto && tiposEmpresa.length > 0 && tiposEmpresa[0].EmpresaIndividuos == c.EmpresaIndividuos)) })),
        GET_PRODUCTO_CAMPO: getProductFieldParam,
        GET_PRODUCTO_REGLA: getProductRuleParam,
        GET_PARAMETRO_GENERAL: parametroGeneral, 
        //GET_ALTA_PRODUCTO_CABAL: GET_ALTA_PRODUCTO_CABAL,
        GET_FUNCIONAMIENTO_LIMITES: funcionamientoLimites,
        GET_DENOMINACION_CUARTA_LINEA: denominacionCuartaLineas,
        GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA: tiposEmpresa,
        GET_COMERCIALIZADORA_CANAL_VENTA_BY_ADMIN: comercializadoras,
        GET_ATLAS_HABILITACION_TARJETA: habilitacionTarjetas,
        GET_ATLAS_SEGMENTO_CARTERA: segmentoCarteras,
        GET_ATLAS_MARCA_COMPARTIDA: marcaCompartidas,
        GET_INGRESO_SOLICITUDES: solicitudEstados,
        GET_COSTO_EMISIONES: costoEmisiones,
        GET_USO_CAJERO_AUTOMATICO: usoCajerosAutomaticos,
        GET_ATLAS_TIPO_COMUNICACION: tipoComunicaciones,
        GET_SENAL_PRE_EMISION_CABAL: senalPreEmision,
        GET_PRE_EMISION_CABAL: preEmision,
        GET_ALTA_POSDATADA: altaPosDatada,
        GET_RETENCION_TARJETA_CABAL: retencionTarjetaCabal,
        selectedAdministrator,
        //Nombre: "",
        //GET_PRODUCTO_CABAL: productoCabal,
        GET_PRODUCTO_DEFAULT_CABAL: productoDefaultCabal,
        edicion: (_productoId && _productoId != "0"),
        topePagoMinimoCabalDefault: (producto && productoDefaultCabal && productoDefaultCabal[0]) && productoDefaultCabal[0].TopePagoMinimoDefault, //Se agrega condición "productoDefaultCabal && " 
        topePagoMinimoCabalMax: (producto && productoDefaultCabal) && producto.topePagoMinimoCabalMax,                // para que no busque propiedad de undefined
        topePagoMinimoCabalMin: (producto && productoDefaultCabal) && producto.topePagoMinimoCabalMin,                    // cuando se trate de Visa y no Cabal.
        establecerPorCuenta: (producto && productoDefaultCabal) && producto.TopePagoMinimoXCuenta,
        topePagoMinimoCabalDefaultInterfaz: (producto && productoDefaultCabal && productoDefaultCabal[0]) ? productoDefaultCabal[0].TopePagoMinimoDefaultInterfaz : true
    }
    
    if(!producto && parametroGeneral){
        result.SolicitudEstadoId = parametroGeneral.ESTADOSOLICITUDINGRESOID
        result.TipoCorrespondenciaId = parametroGeneral.TIPOCOMUNICACIONID
    }

    if(producto){
        result.TipoCorrespondenciaId = producto.TipoCorrespondenciaId
    }


    if (_productoId && _productoId != "0" && selectedAdministrator == "C" && productoDefaultCabal) { // a partir de acá se checkea que los defaults del producto no pasaron a estar inactivos

        let defaults = productoDefaultCabal[0]

        function _inactivo(id,array){
            return array.some(i=>i.Id == id && i.noDisponible)
        }

        producto.AsociaGrupoAfinidad = producto.AsociaGrupoAfinidad
        producto.GrupoAfinidadDefaultId = _inactivo(defaults.GrupoAfinidadDefaultId,gruposAfinidad) ? null : defaults.GrupoAfinidadDefaultId;
        producto.GrupoAfinidadDefaultInterfaz = defaults.GrupoAfinidadDefaultInterfaz;

        producto.AsociaSegmentoCartera = producto.AsociaSegmentoCartera
        producto.SegmentoCarteraDefaultId = _inactivo(defaults.SegmentoCarteraDefaultId,segmentoCarteras) ? null : defaults.SegmentoCarteraDefaultId;
        producto.SegmentoCarteraDefaultInterfaz = defaults.SegmentoCarteraDefaultInterfaz;

        producto.AsociaMarcaCompartida = producto.AsociaMarcaCompartida
        producto.MarcaCompartidaDefaultId = _inactivo(defaults.MarcaCompartidaDefaultId,marcaCompartidas) ? null : defaults.MarcaCompartidaDefaultId;
        producto.MarcaCompartidaDefaultInterfaz = defaults.MarcaCompartidaDefaultInterfaz;

        producto.FormaPagoDefaultId= _inactivo(defaults.FormaPagoDefaultId,formasPago) ? null :  defaults.FormaPagoDefaultId;
        producto.FormaPagoDefaultInterfaz= defaults.FormaPagoDefaultInterfaz;

        producto.TipoDebitoDefaultId= _inactivo(defaults.TipoDebitoDefaultId,formasDebito) ? null :  defaults.TipoDebitoDefaultId;
        producto.TipoDebitoDefaultInterfaz = defaults.TipoDebitoDefaultInterfaz == null ? true : defaults.TipoDebitoDefaultInterfaz;

        producto.CarteraDefaultId =  _inactivo(defaults.CicloFacturacionDefaultId,carteras) ? null :  defaults.CicloFacturacionDefaultId;
        
    }else if(_productoId && _productoId != "0" && selectedAdministrator == "V" ){
        let defaults = producto

        function _inactivo(id,array){
            return array.some(i=>i.Id == id && i.noDisponible)
        }

        producto.GrupoAfinidadDefaultId = _inactivo(defaults.GrupoAfinidadDefaultId,gruposAfinidad) ? null : defaults.GrupoAfinidadDefaultId;
        
        producto.FormaPagoDefaultId= _inactivo(defaults.FormaPagoDefaultId,formasPago) ? null :  defaults.FormaPagoDefaultId;
        
        producto.TipoDebitoDefaultId= _inactivo(defaults.TipoDebitoDefaultId,formasDebito) ? null :  defaults.TipoDebitoDefaultId;
        producto.TipoDebitoDefaultInterfaz = defaults.TipoDebitoDefaultInterfaz == null ? true : defaults.TipoDebitoDefaultInterfaz;
        
        producto.CarteraDefaultId =  _inactivo(defaults.CarteraDefaultId,carteras) ? null :  defaults.CarteraDefaultId;

        producto.CategoriaCajeroDefaultId = _inactivo(defaults.CategoriaCajeroDefaultId,categoriasAtm) ? null :  defaults.CategoriaCajeroDefaultId;

        producto.CodigoDistribucionDefaultId = _inactivo(defaults.CodigoDistribucionDefaultId,codigosDistribucion) ? null :  defaults.CodigoDistribucionDefaultId;

        producto.LimitePrestamoDefaultId = _inactivo(defaults.LimitePrestamoDefaultId,lineasPrestamo) ? null :  defaults.LimitePrestamoDefaultId;

        producto.ComercializadoraCanalDefaultIdFront = _agregarDefaultInterfazComercializadora(producto.ComercializadoraCanalDefaultId,comercializadoras);
        
    }
    
    _dispatch({ type: GET_DATA_BY_ADMINISTRATOR_ID_PRODUCTO, data: result, producto });
}

/**
 * 
 * @param {any} data
 * @param {any} tabla
 * @param {any} advancedRuleId
 * @param {any} optionType
 */
function _loadOptionsByFieldData(data, tabla, advancedRuleId, optionType) {
    LogHelper.In(_loadOptionsByFieldData.name, data, tabla, advancedRuleId, optionType);

    // return (dispatch, getState) => {

    let result = {
        GET_PRODUCTO_OPCION_CAMPO: getOptionsByFieldParam
    }
    //_dispatch = dispatch;
    _dispatch({ type: GET_OPTIONS_BY_FIELD_PRODUCTO, data: result, tabla: tabla, advancedRuleId: advancedRuleId, optionType: optionType });
    //}
}

/**
 * 
 * @param {any} result
 * @param {any} disconectCallback
 */
function ejecutarPorEstado(result, disconectCallback) {
    LogHelper.In(ejecutarPorEstado.name, result, disconectCallback);

    let type;
    let modalId;
    //ESTADO Descripcion
    //1	     Iniciada
    //2	     Completada
    //3	     Error
    //4	     CompletadaConDependencias
    //5	     CompletadaErrores
    //6	     Abortada
    //7	     EnCancelacion

    switch (result.Estado) {
        case 2:
            modalId = "completada";
            break;
        case 3:
            modalId = "error";
            break;
        case 4:
            modalId = "completadaConDependencias";
            break;
        case 5:
            modalId = "error";
            break;
    }
    $("#" + modalId).modal();
    _dispatch({ type: SHOW_SAVE_STATUS_PRODUCTO, sagaId: result.SagaId, modalId: modalId });
    disconectCallback();
}



function _createArrayProducto(atlasParam, productosParam, column, columnId, edicion, agregaSeleccione = true, defaultTrue) {
    const atlasCopy = JSON.parse(JSON.stringify(atlasParam));

    atlasCopy.forEach(function (i) {
        
        i.Checked = defaultTrue ? true : false;

        productosParam.forEach(function (i2) {
        
            if (i.Id == i2[columnId]) {
        
                i.Checked = true;
                i[columnId] = i2[columnId];
                i[column] = i2.Id;
                

                if (edicion) {
                    i.Cambio = false;
                }
            }
        });
    });

    if (agregaSeleccione) {
        atlasCopy.unshift({ Id: 0, Descripcion: "Seleccione...", Checked: true });
    }

    return atlasCopy;
}

/**
 * 
 * @param {any} arregloAtlas 
 * @param {any} arregloProductoGuardado 
 */

function _checkActivo(arregloAtlas,arregloProductoGuardado){
    const arrayOriginal = JSON.parse(JSON.stringify(arregloProductoGuardado))

    arregloProductoGuardado.forEach(item=>{ // Si es una modificación va a poner como inactivos a los que ya no estén entre las opciones
        item.Activo = false; // primero a todos
        item.Checked = false;
        arregloAtlas.forEach(item2=>{ //después comparando todas las opciones actuales
            if(item2.Activo == true && item2.Id == item.Id){
                item.Activo = true;
                arrayOriginal.forEach(item3=>{ // por último se compara con el array de selecciones original para asignarle check true a lo que corresponda
                    if(item3.Checked == true && item.Id == item3.Id) item.Checked = true
                })
            }else if(item2.Activo == false && item.Id == item2.Id ){ // si no está activo y no se seleccionó se elimina de la lista
                arrayOriginal.forEach(item4=>{ // por último se compara con el array de selecciones original para asignarle check true a lo que corresponda
                    if(!item4.Checked && item.Id == item4.Id){
                        item.Eliminar = true
                    }else if(item4.Checked && item.Id == item4.Id){
                        item.noDisponible = true
                        item.Checked = false
                    }
                })
            } 
        })
    })
    return arregloProductoGuardado = arregloProductoGuardado.filter(item=>!item.Eliminar)
}

function _agregarDefaultInterfazComercializadora(idRelacion,arreglo){
    if(idRelacion){
        let idFront = ""

        arreglo.length>0 && arreglo.map(comercializadora=>{
            comercializadora.CanalVentas.map(canal=>{
                if(canal.RelacionId==idRelacion){
                    idFront += comercializadora.Id;
                    idFront += "-"
                    idFront += canal.Id
                }
            })
        })

        return idFront != "-" ? idFront : null

    }else{
        return null
    }
}